import {
  MutationCache,
  QueryCache,
  QueryClient,
} from "@tanstack/react-query"
import { toast } from "sonner"

function toastApiError(error: unknown) {
  const message =
    error instanceof Error ? error.message : "Something went wrong"
  toast.error(message)
}

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: toastApiError,
  }),
  mutationCache: new MutationCache({
    onError: toastApiError,
  }),
})
